import * as React from 'react';
import { Route } from 'react-router-dom';
import HomeContainer from './Containers/homeContainer';
import AboutUsContainer from './Containers/aboutUsContainer';
import ServicesContainer from './Containers/servicesContainer';
import ContactsContainer from './Containers/contactsContainer';

export const routes = <div>
    <Route exact path="/" component={HomeContainer} />
    <Route exact path="/aboutus" component={AboutUsContainer} ></Route>
    <Route exact path="/services" component={ServicesContainer} ></Route>
    <Route exact path="/contacts" component={ContactsContainer} ></Route>
</div>


// WEBPACK FOOTER //
// ./ClientApp/app/routes.tsx